import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    mapboxAccessToken: null,
};
var mapboxSlice = createSlice({
    name: 'mapbox',
    initialState: initialState,
    reducers: {
        setMapboxAccessToken: function (state, action) {
            state.mapboxAccessToken = action.payload;
        },
    },
});
export var setMapboxAccessToken = mapboxSlice.actions.setMapboxAccessToken;
export default mapboxSlice.reducer;
